export function formatReadonlyValue(value?: string | null): string {
  const normalized = (value || '').trim();
  return normalized.length > 0 ? normalized : '——';
}
